import axios from "axios"
import { appConstants } from '../_constants';
import { notification } from 'antd';
export const request = (path, data, method) => {
      return axios({
        method: method,
        url: `${appConstants.WEB_SERVICE_URL}/${path}`,
          headers: {
            'crossDomain': true, 
            changeOrigin: true,          
            "authorization":"Key@123"           
          },
        data:data
      }).catch(function (error) {
            console.log("error",error)
      if (error.response) {
        //console.log("lll",error.response.data);
        notification.error({
                message: error.response.data.msg,
                className:'errorNotification',
                duration: 3
            });
      } else if (error.request) {
        //console.log("kk",error.request);
      } else {
        //console.log('Error', error.message);
      }
      console.log(error.config);
     });
}


export const requestss = (path, data, method) => {
      return axios({
        method: method,
        url:path,
          headers: {
            'crossDomain': true ,
            changeOrigin: true,
            'content-type':"Json",
            "authorization":"Key@123"           
          }
      })
}
export const postRequestWithoutSession = (path, data) => request(path, data, "POST");
export const getRequestWithoutSession = (path, data) => requestss(path, data, "GET");



// WEBPACK FOOTER //
// ./src/api/helper-without-session.js